import "core-js/modules/es.array.includes.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/winwing_logo.png';

const _withScopeId = n => (_pushScopeId("data-v-782ffd36"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "flex-center",
  style: {
    "width": "100%",
    "height": "100%",
    "align-content": "center"
  }
};
const _hoisted_2 = {
  class: "flex-start"
};
const _hoisted_3 = {
  style: {
    "font-size": "0.9rem"
  }
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("time ");

const _hoisted_5 = {
  style: {
    "width": "80vw",
    "max-height": "85vh",
    "overflow": "scroll"
  }
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  style: {
    "width": "100%",
    "height": "50px"
  }
};
const _hoisted_8 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "200px",
    "height": "50px",
    "padding": "6px 0 7.5px 10px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "height": "35px",
    "object-fit": "contain"
  }
})], -1));

const _hoisted_10 = {
  style: {
    "width": "300px",
    "height": "50px",
    "display": "flex",
    "justify-content": "space-around",
    "align-items": "center"
  }
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("结转");

const _hoisted_12 = {
  style: {
    "width": "35px",
    "height": "35px",
    "border-radius": "50%",
    "background-color": "rgb(243,243,243)",
    "overflow": "hidden"
  }
};
const _hoisted_13 = {
  style: {
    "width": "150px",
    "height": "100%",
    "display": "flex",
    "justify-content": "space-around",
    "align-items": "center"
  }
};
const _hoisted_14 = {
  style: {
    "cursor": "pointer",
    "color": "rgb(2,183,0)"
  }
};
const _hoisted_15 = ["value"];
const _hoisted_16 = {
  class: "flex-start",
  style: {
    "width": "100%",
    "height": "calc(100vh - 50px)",
    "flex-wrap": "nowrap"
  }
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("Filter");

const _hoisted_18 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_19 = {
  class: "flex-start",
  style: {
    "flex-wrap": "nowrap",
    "overflow": "auto auto",
    "align-items": "flex-start",
    "padding": "0 .4rem"
  }
};
const _hoisted_20 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "align-content": "center",
    "height": "100%",
    "margin-left": "1rem"
  }
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode("搜索");

const _hoisted_22 = {
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_23 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    "height": "100%",
    "width": "100%",
    "overflow": "visible"
  }
};
const _hoisted_24 = {
  style: {
    "white-space": "nowrap",
    "overflow": "auto",
    "width": "100%"
  }
};
const _hoisted_25 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%",
    "padding": "0 1rem 0 0"
  }
};
const _hoisted_26 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_27 = {
  style: {
    "font-size": ".8rem",
    "font-weight": "bold",
    "width": "100%",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_28 = {
  key: 0,
  style: {
    "color": "red",
    "margin-left": ".2rem",
    "font-size": ".8rem",
    "font-weight": "bold"
  }
};
const _hoisted_29 = {
  style: {
    "color": "red",
    "font-weight": "bold",
    "font-size": ".8rem"
  }
};
const _hoisted_30 = {
  class: "",
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center"
  }
};
const _hoisted_31 = {
  ref: "recordListRef",
  class: "infinite-list-wrapper",
  "infinite-scroll-distance": "15",
  style: {
    "width": "14%",
    "min-width": "14%",
    "height": "100%",
    "overflow": "hidden scroll",
    "border-bottom": "1px solid #777"
  }
};
const _hoisted_32 = {
  style: {
    "border-bottom": "1px solid #999"
  }
};
const _hoisted_33 = {
  class: "person_title",
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "padding": ".2rem",
    "align-items": "center"
  }
};
const _hoisted_34 = {
  style: {
    "color": "white",
    "font-weight": "bold",
    "font-size": "1.2rem"
  }
};
const _hoisted_35 = {
  style: {
    "color": "white",
    "font-weight": "bold",
    "font-size": "1.2rem",
    "user-select": "none"
  }
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  key: 0,
  style: {
    "background-color": "white",
    "color": "rgb(230,162,60)",
    "width": "80px",
    "height": "20px",
    "border-radius": "10px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_38 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "justify-content": "space-between"
  }
};
const _hoisted_39 = {
  style: {
    "font-size": "1rem",
    "user-select": "none"
  }
};
const _hoisted_40 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_41 = {
  key: 0,
  style: {
    "font-size": "12px",
    "background-color": "#E6A23C",
    "font-weight": "bold",
    "color": "white",
    "border-radius": "50%",
    "min-width": "26px",
    "max-width": "26px",
    "height": "26px",
    "text-align": "center",
    "line-height": "26px"
  }
};
const _hoisted_42 = {
  style: {
    "width": "10%"
  },
  class: "flex-start"
};
const _hoisted_43 = {
  key: 0,
  class: "flex-center",
  style: {
    "background-color": "#D2746A",
    "border-radius": "4rem",
    "min-width": "1.5rem",
    "height": "1.5rem",
    "color": "#fff"
  }
};
const _hoisted_44 = ["onContextmenu"];
const _hoisted_45 = ["onClick", "onKeydown", "onBlur", "onUpdate:modelValue", "onChange"];
const _hoisted_46 = {
  class: "btn_box"
};
const _hoisted_47 = ["onClick"];
const _hoisted_48 = ["onClick"];
const _hoisted_49 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "width": "100%",
    "justify-content": "center",
    "padding": ".4rem"
  }
};

const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-loading"
}, null, -1));

const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "artistic-text",
  style: {
    "margin-left": ".5rem",
    "font-size": "1rem",
    "font-weight": "bold"
  }
}, "Loading...", -1));

const _hoisted_52 = [_hoisted_50, _hoisted_51];
const _hoisted_53 = {
  key: 1,
  class: "artistic-text",
  style: {
    "font-size": "1.2rem",
    "width": "100%",
    "text-align": "center",
    "padding": ".4rem",
    "font-weight": "bold"
  }
};
const _hoisted_54 = {
  key: 0,
  style: {
    "height": "100%",
    "border-left": "1px solid #ccc",
    "border-right": "1px solid #ccc",
    "flex": "1"
  }
};
const _hoisted_55 = {
  style: {
    "width": "100%",
    "height": "2rem",
    "position": "fixed",
    "z-index": "666"
  },
  class: "flex-start"
};
const _hoisted_56 = {
  style: {
    "width": "80px",
    "font-size": "16px",
    "margin-left": "10px",
    "text-align": "center",
    "overflow": "hidden",
    "white-space": "nowrap",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_57 = {
  key: 0,
  style: {
    "margin-left": "30px",
    "font-size": "16px"
  }
};
const _hoisted_58 = {
  key: 1,
  style: {
    "width": "300px",
    "font-size": "16px",
    "margin-left": "30px",
    "overflow": "hidden",
    "white-space": "nowrap",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_59 = {
  style: {
    "font-size": "16px",
    "margin": "0 10px"
  }
};
const _hoisted_60 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "width": "100%",
    "height": "100%",
    "padding-top": "32px"
  }
};
const _hoisted_61 = {
  style: {
    "width": "100%",
    "height": "100%",
    "position": "relative"
  }
};
const _hoisted_62 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "width": "100%",
    "height": "100%",
    "justify-content": "space-between",
    "grid-template-columns": "1fr 1fr"
  }
};
const _hoisted_63 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "100%",
    "height": "100%",
    "position": "relative"
  }
};
const _hoisted_64 = ["onContextmenu"];
const _hoisted_65 = ["onContextmenu"];
const _hoisted_66 = ["innerHTML"];
const _hoisted_67 = ["innerHTML"];
const _hoisted_68 = ["onClick"];
const _hoisted_69 = ["onContextmenu"];
const _hoisted_70 = ["onClick"];
const _hoisted_71 = {
  style: {
    "width": "100%",
    "height": "40%",
    "position": "relative"
  }
};
const _hoisted_72 = {
  style: {
    "position": "absolute",
    "top": ".2rem",
    "left": "6rem"
  }
};
const _hoisted_73 = {
  key: 1,
  class: "success_btn"
};
const _hoisted_74 = {
  key: 2,
  class: "success_btn"
};
const _hoisted_75 = {
  key: 3,
  style: {
    "margin-left": ".5rem",
    "font-size": ".8rem",
    "font-weight": "bold"
  }
};
const _hoisted_76 = {
  style: {
    "position": "absolute",
    "width": "100%",
    "bottom": "2.5rem",
    "right": "1rem",
    "z-index": "999"
  },
  class: "flex-end"
};
const _hoisted_77 = ["disabled"];
const _hoisted_78 = ["disabled"];
const _hoisted_79 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "100%",
    "position": "relative",
    "border-left": "1px solid #000"
  }
};
const _hoisted_80 = {
  ref: "scrollRef",
  style: {
    "width": "100%",
    "height": "calc(60% - 1.8rem)",
    "border-top": "1px solid #777",
    "padding": "1rem",
    "overflow-y": "scroll",
    "scroll-behavior": "auto",
    "position": "relative"
  }
};
const _hoisted_81 = {
  style: {
    "width": "100%",
    "flex-wrap": "wrap",
    "margin-bottom": "0.2rem"
  },
  class: "flex-start"
};
const _hoisted_82 = ["innerHTML"];
const _hoisted_83 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};

const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-loading"
}, null, -1));

const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-align": "center",
    "font-size": "1rem",
    "margin-left": ".5rem"
  }
}, "Loading...", -1));

const _hoisted_86 = [_hoisted_84, _hoisted_85];
const _hoisted_87 = {
  style: {
    "width": "100%",
    "height": "40%",
    "border-top": "1px solid #777",
    "border": "1px solid #777"
  }
};
const _hoisted_88 = {
  style: {
    "border-bottom": "1px solid black",
    "padding": ".2rem .5rem"
  },
  class: "flex-end"
};
const _hoisted_89 = ["disabled"];
const _hoisted_90 = {
  style: {
    "position": "absolute",
    "width": "100%",
    "bottom": "2.5rem",
    "right": "1rem",
    "z-index": "999"
  },
  class: "flex-end"
};
const _hoisted_91 = ["disabled"];
const _hoisted_92 = {
  key: 0,
  style: {
    "height": "500px",
    "width": "1320px",
    "overflow": "scroll"
  }
};
const _hoisted_93 = ["onClick"];

const _hoisted_94 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  }
}, "Name: ", -1));

const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  }
}, "Telephone num: ", -1));

const _hoisted_96 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  }
}, "Country: ", -1));

const _hoisted_97 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  }
}, "State: ", -1));

const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  }
}, "City: ", -1));

const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  }
}, "District: ", -1));

const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  }
}, "Detailed address: ", -1));

const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  }
}, "Postal code: ", -1));

const _hoisted_102 = /*#__PURE__*/_createTextVNode("下载发票");

const _hoisted_103 = {
  key: 1,
  style: {
    "height": "500px",
    "width": "1320px",
    "overflow-x": "scroll",
    "border-bottom": "1px solid #eee"
  }
};

const _hoisted_104 = /*#__PURE__*/_createTextVNode(" 查看报损单 ");

const _hoisted_105 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "height": "60px",
    "border-top": "1px solid black"
  },
  class: "templPageC"
};
const _hoisted_106 = {
  key: 2,
  style: {
    "height": "100%",
    "width": "1320px",
    "overflow": "scroll"
  }
};
const _hoisted_107 = {
  key: 1,
  style: {
    "height": "100%",
    "border-left": "1px solid #ccc",
    "border-right": "1px solid #ccc",
    "flex": "1",
    "font-size": "24px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_108 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    "height": "100%"
  }
};
const _hoisted_109 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "justify-content": "flex-end",
    "position": "sticky",
    "bottom": "0",
    "left": "0",
    "right": "0"
  },
  class: "demo-drawer__footer"
};

const _hoisted_110 = /*#__PURE__*/_createTextVNode("取 消");

const _hoisted_111 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_112 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    "height": "95%"
  }
};
const _hoisted_113 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "justify-content": "flex-end",
    "position": "sticky",
    "bottom": "-20px",
    "left": "0",
    "right": "0",
    "z-index": "666"
  },
  class: "demo-drawer__footer"
};

const _hoisted_114 = /*#__PURE__*/_createTextVNode("取 消");

const _hoisted_115 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_116 = {
  style: {
    "text-align": "center",
    "font-size": "16px"
  }
};
const _hoisted_117 = {
  style: {
    "position": "absolute",
    "display": "block",
    "background-color": "black",
    "color": "white",
    "padding": "5px",
    "border-radius": "4px",
    "z-index": "10",
    "left": "500px",
    "top": "500px",
    "word-break": "break-all"
  },
  class: "toolTips"
};

const _hoisted_118 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "20px",
    "font-weight": "bold",
    "text-align": "left"
  }
}, " 提示 ", -1));

const _hoisted_119 = {
  style: {}
};
const _hoisted_120 = {
  style: {
    "display": "flex"
  }
};

const _hoisted_121 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "16px",
    "font-weight": "bold",
    "margin-left": "20px",
    "text-align": "left"
  }
}, "退出确认"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "20px",
    "margin-bottom": "50px",
    "text-align": "left"
  }
}, "您确定要退出登录吗?")], -1));

const _hoisted_122 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};

const _hoisted_123 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_124 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_125 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "20px",
    "font-weight": "bold",
    "text-align": "left"
  }
}, " 提示 ", -1));

const _hoisted_126 = {
  style: {}
};
const _hoisted_127 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_128 = {
  style: {
    "font-size": "16px",
    "font-weight": "bold",
    "margin-left": "20px",
    "text-align": "left"
  }
};
const _hoisted_129 = {
  style: {
    "margin-left": "20px",
    "margin-bottom": "50px",
    "text-align": "left"
  }
};
const _hoisted_130 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};

const _hoisted_131 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_132 = /*#__PURE__*/_createTextVNode("确定");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Modal = _resolveComponent("Modal");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_icon_Avatar = _resolveComponent("el-icon-Avatar");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_divider = _resolveComponent("el-divider");

  const _component_FilterPanel2 = _resolveComponent("FilterPanel2");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_collapse_item = _resolveComponent("el-collapse-item");

  const _component_el_collapse = _resolveComponent("el-collapse");

  const _component_el_header = _resolveComponent("el-header");

  const _component_el_icon_Expand = _resolveComponent("el-icon-Expand");

  const _component_el_icon_Fold = _resolveComponent("el-icon-Fold");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_tree = _resolveComponent("el-tree");

  const _component_el_badge = _resolveComponent("el-badge");

  const _component_el_image_viewer = _resolveComponent("el-image-viewer");

  const _component_templateTicket = _resolveComponent("templateTicket");

  const _component_Editor = _resolveComponent("Editor");

  const _component_el_icon_Loading = _resolveComponent("el-icon-Loading");

  const _component_el_popconfirm = _resolveComponent("el-popconfirm");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_dialog = _resolveComponent("el-dialog");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_templateDemo = _resolveComponent("templateDemo");

  const _component_Catalogue = _resolveComponent("Catalogue");

  const _component_el_drawer = _resolveComponent("el-drawer");

  const _component_Assignment = _resolveComponent("Assignment");

  const _component_el_main = _resolveComponent("el-main");

  const _component_el_container = _resolveComponent("el-container");

  const _component_templatePop_1 = _resolveComponent("templatePop_1");

  const _component_el_icon_Warning = _resolveComponent("el-icon-Warning");

  const _directive_localStorage = _resolveDirective("localStorage");

  const _directive_infinite_scroll = _resolveDirective("infinite-scroll");

  const _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Modal, {
    show: $data.viewQuestionStepModalShow,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.viewQuestionStepModalShow = $event)
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString($options.questionRecordSelected.user.name), 1), _createElementVNode("div", _hoisted_3, " [" + _toDisplayString($options.questionRecordSelected.create_time) + "]： ", 1), _hoisted_4, _createElementVNode("div", null, _toDisplayString($options.getNav($options.questionRecordSelected.id).join('→')), 1)])]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
      innerHTML: $options.questionRecordSelected.step_record
    }, null, 8, _hoisted_6)])]),
    footer: _withCtx(() => []),
    _: 1
  }, 8, ["show"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
    type: "primary",
    style: {
      "margin": "0 20px"
    },
    onClick: $options.clickCarryOver
  }, {
    default: _withCtx(() => [_hoisted_11]),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_icon, {
    style: {
      "font-size": "35px",
      "color": "gray"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon_Avatar)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, _toDisplayString($data.personInfoServer.name), 1), _createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("select", {
    name: "",
    id: "",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.workStatusVal = $event),
    onChange: _cache[2] || (_cache[2] = (...args) => $options.workStatusChange && $options.workStatusChange(...args)),
    style: _normalizeStyle([{
      "color": "rgb(2,183,0)",
      "border": "none"
    }, {
      color: $data.workStatusVal ? 'rgb(2,183,0)' : 'red'
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.workStatusOption, item => {
    return _openBlock(), _createElementBlock("option", {
      value: item.value
    }, _toDisplayString(item.label), 9, _hoisted_15);
  }), 256))], 36), [[_vModelSelect, $data.workStatusVal]])])])])])]), _createElementVNode("div", _hoisted_16, [_withDirectives((_openBlock(), _createBlock(_component_el_container, {
    style: {
      "width": "100%",
      "min-width": "16rem",
      "height": "100%"
    },
    "element-loading-text": '拼命加载中...' + $data.loadingTextArray.join(),
    "element-loading-spinner": "el-icon-loading",
    "element-loading-background": "rgba(0, 0, 0, 0.5)"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      style: {
        "width": "100%",
        "height": "fit-content",
        "padding": "0px",
        "border-top": "1px solid #777"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_collapse, {
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
          title: "Filter",
          name: "1"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_divider, {
            "content-position": "left",
            style: {
              "height": "2px"
            }
          }, {
            default: _withCtx(() => [_hoisted_17]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_withDirectives(_createVNode(_component_FilterPanel2, {
            modelValue: $data.checkedSolveOptions,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.checkedSolveOptions = $event),
            options: $data.solveOptions,
            title: _ctx._t('mixed')
          }, null, 8, ["modelValue", "options", "title"]), [[_directive_localStorage, {
            checkedSolveOptions: $data.checkedSolveOptions
          }]]), _withDirectives(_createVNode(_component_FilterPanel2, {
            modelValue: $data.questionTypeSelected,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.questionTypeSelected = $event),
            options: $data.questionTypeOptions,
            title: "QuestionType"
          }, null, 8, ["modelValue", "options"]), [[_directive_localStorage, {
            questionTypeSelected: $data.questionTypeSelected
          }]]), _withDirectives(_createVNode(_component_FilterPanel2, {
            modelValue: $data.questionCustomerIdArray,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.questionCustomerIdArray = $event),
            options: $data.questionCustomerArray,
            title: "Customer Service",
            label: "name"
          }, null, 8, ["modelValue", "options"]), [[_directive_localStorage, {
            questionCustomerIdArray: $data.questionCustomerIdArray
          }]]), _withDirectives(_createVNode(_component_FilterPanel2, {
            modelValue: $data.emergencyDegreeSelect,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.emergencyDegreeSelect = $event),
            options: $data.emergencyDegreeOption,
            title: "Emergency Degree",
            label: "val"
          }, null, 8, ["modelValue", "options"]), [[_directive_localStorage, {
            emergencyDegreeSelect: $data.emergencyDegreeSelect
          }]]), _createVNode(_component_FilterPanel2, {
            modelValue: $data.regionSelect,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.regionSelect = $event),
            options: $data.regionOption,
            title: "Region",
            label: "dictLabel"
          }, null, 8, ["modelValue", "options"]), _createVNode(_component_FilterPanel2, {
            modelValue: $data.schedulingSelect,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.schedulingSelect = $event),
            options: $data.schedulingOption,
            title: "客诉班次",
            label: "dictLabel"
          }, null, 8, ["modelValue", "options"])]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_input, {
            placeholder: "请输入客户昵称或问题备注",
            clearable: "",
            "prefix-icon": _ctx.Search,
            style: {
              "width": "250px"
            },
            type: "text",
            modelValue: $data.clientName,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.clientName = $event)
          }, null, 8, ["prefix-icon", "modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[10] || (_cache[10] = $event => $options.submitclientName()),
            style: {
              "margin-left": ".5rem"
            }
          }, {
            default: _withCtx(() => [_hoisted_21]),
            _: 1
          })])])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_main, {
      style: {
        "width": "100%",
        "padding": "0px",
        "height": "100%",
        "overflow": "hidden"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
        style: _normalizeStyle([{
          width: $data.isHidden ? '2%' : '16%'
        }, {
          "height": "100%",
          "flex-direction": "column",
          "padding": ".5rem 0 2rem 0",
          "resize": "horizontal",
          "overflow": "hidden"
        }]),
        ref: "dragContainer"
      }, [_createElementVNode("div", {
        onClick: _cache[11] || (_cache[11] = $event => $options.clickHidden()),
        style: {
          "display": "flex",
          "justify-content": "flex-end",
          "padding-right": ".5rem"
        }
      }, [$data.isHidden ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        size: 20,
        style: {
          "cursor": "pointer"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon_Expand)]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1,
        size: 20,
        style: {
          "cursor": "pointer"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon_Fold)]),
        _: 1
      }))]), $data.isHidden === false ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_tree, {
        "highlight-current": "",
        "node-key": "id",
        data: $data.treeListData,
        props: $data.defaultProps,
        onNodeClick: $options.clickQuestionCatalog
      }, {
        default: _withCtx(({
          node,
          data
        }) => [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_tooltip, {
          content: data.name,
          placement: "right",
          effect: "customized",
          "show-after": 500,
          enterable: false
        }, {
          default: _withCtx(() => [_createElementVNode("p", _hoisted_27, _toDisplayString(data.name), 1)]),
          _: 2
        }, 1032, ["content"]), data.id != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_28, "(" + _toDisplayString(data.sopSumNum) + ")", 1)) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_29, _toDisplayString(data.sumNum), 1)])]),
        _: 1
      }, 8, ["data", "props", "onNodeClick"])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", {
        onClick: _cache[12] || (_cache[12] = $event => $options.clickSopAdmin()),
        class: "text_style",
        style: {
          "width": "100%",
          "height": "3rem",
          "cursor": "pointer",
          "font-size": "1rem",
          "font-weight": "bold",
          "line-height": "3rem",
          "text-align": "center"
        }
      }, " SOP管理页面")])])) : _createCommentVNode("", true)], 4), _createElementVNode("div", {
        onMousedown: _cache[13] || (_cache[13] = (...args) => $options.startDrag && $options.startDrag(...args)),
        style: {
          "cursor": "e-resize",
          "border": "1px solid #eee",
          "height": "100%",
          "min-width": "10px"
        },
        class: "drag_box"
      }, null, 32), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questionRecordList, (items, _index) => {
        return _openBlock(), _createElementBlock("div", {
          key: _index,
          style: {
            "border": "1px solid #ccc",
            "margin-bottom": ".2rem"
          }
        }, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("span", _hoisted_34, [_createVNode(_component_el_badge, {
          "is-dot": "",
          type: items.isOnLine ? 'success' : 'info',
          class: "el_item"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(JSON.parse(items.user)?.name || ''), 1)]),
          _: 2
        }, 1032, ["type"])]), _createElementVNode("span", _hoisted_35, _toDisplayString(items.unread) + "/" + _toDisplayString(items.unsolved), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.item, (record, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(record.is_solved == 1 ? 'solved' : ''),
            key: index,
            onClick: $event => $options.clickQuestionRecord(record, index),
            style: _normalizeStyle([{
              'background-color': record.id === $data.selectItem ? '#FFC1C1' : '#FFF0F5'
            }, {
              "display": "flex",
              "flex-direction": "column",
              "justify-content": "flex-start",
              "position": "relative",
              "padding": ".5rem",
              "border-bottom": "1px dashed #aaa"
            }])
          }, [record.isAbnormal ? (_openBlock(), _createElementBlock("div", _hoisted_37, "回复异常")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, _toDisplayString(record.create_time), 1), _createElementVNode("div", _hoisted_40, [record.urgrncy_level && record.urgrncy_level == 'P1' ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(record.urgrncy_level), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_42, [record.admin_unread != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(record.admin_unread), 1)) : _createCommentVNode("", true)])])]), _createVNode(_component_el_tooltip, {
            content: record.type_title,
            placement: "top",
            effect: "customized",
            "show-after": 500,
            enterable: false,
            "popper-class": "atooltip"
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              onContextmenu: _withModifiers($event => $options.copyContent(record), ["prevent"]),
              style: {
                "font-size": "1rem",
                "user-select": "none"
              },
              class: "text_box"
            }, _toDisplayString(record.type_title), 41, _hoisted_44)]),
            _: 2
          }, 1032, ["content"]), _withDirectives(_createElementVNode("textarea", {
            onClick: _withModifiers($event => $options.stopClickPropagation($event, record), ["stop"]),
            onKeydown: _withKeys(_withModifiers($event => $options.submitContent(record), ["exact"]), ["enter"]),
            onBlur: $event => $options.submitContent(record),
            class: _normalizeClass(record.is_solved == 1 ? 'textareaSolved' : ''),
            "onUpdate:modelValue": $event => record.comment = $event,
            rows: "3",
            onChange: $event => _ctx.clickChangeQuestionRecordComment(record),
            style: {
              "resize": "none",
              "width": "100%",
              "font-size": "1.2rem",
              "border": "1px solid #ccc"
            }
          }, null, 42, _hoisted_45), [[_vModelText, record.comment]]), _createElementVNode("div", _hoisted_46, [_createElementVNode("p", {
            onClick: _withModifiers($event => $options.clickSortQuestion(record), ["stop"]),
            class: "btns"
          }, "分类", 8, _hoisted_47), _createElementVNode("p", {
            onClick: _withModifiers($event => $options.clickQuestionToCustomer(record), ["stop"]),
            class: "btns"
          }, "分派", 8, _hoisted_48)])], 14, _hoisted_36);
        }), 128))])]);
      }), 128)), $data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_52)) : (_openBlock(), _createElementBlock("p", _hoisted_53, "No more"))])), [[_directive_infinite_scroll, $options.scrollHandler]]), $options.isShowChat() ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: JSON.parse($data.nowChatUserRecordInfo.user)?.name || '',
        placement: "top"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(JSON.parse($data.nowChatUserRecordInfo.user)?.name || ''), 1)]),
        _: 1
      }, 8, ["content"])]), _createElementVNode("button", {
        class: _normalizeClass($data.isShowTable || $data.isTemplShow ? 'btns' : 'btns_green'),
        style: {
          "font-size": ".8rem",
          "background-color": "white"
        },
        onClick: _cache[14] || (_cache[14] = $event => $options.clickViewQuestionStep())
      }, _toDisplayString(_ctx._t('viewUserQuestionStep')), 3), _createElementVNode("button", {
        onClick: _cache[15] || (_cache[15] = $event => $options.clickClientOrderList()),
        class: _normalizeClass($data.isShowTable && $data.isTemplShow == false ? 'btns_green' : 'btns'),
        style: {}
      }, "客户订单列表", 2), _createElementVNode("button", {
        onClick: _cache[16] || (_cache[16] = $event => $options.clicktemplRecord(true)),
        class: _normalizeClass($data.isTemplShow ? 'btns_green' : 'btns'),
        style: {}
      }, "报损单记录", 2), $data.nowChatUserRecordInfo.customer_Name && this.templateDemoShow == false && this.isShowTable == false && this.isTemplShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString($data.nowChatUserRecordInfo.customer_Name) + "---正在处理该工单", 1)) : _createCommentVNode("", true), this.templateDemoShow == false && this.isShowTable == false && this.isTemplShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: `${$data.nowChatUserRecordInfo.sopDirectoryName ? $data.nowChatUserRecordInfo.sopDirectoryName : ''}${$data.nowChatUserRecordInfo.sopDirectoryName && $data.nowChatUserRecordInfo.productionName ? '-' : ''}${$data.nowChatUserRecordInfo.productionName ? $data.nowChatUserRecordInfo.productionName : ''}`,
        placement: "top-start"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(`${$data.nowChatUserRecordInfo.sopDirectoryName ? $data.nowChatUserRecordInfo.sopDirectoryName : ''}` + `${$data.nowChatUserRecordInfo.sopDirectoryName && $data.nowChatUserRecordInfo.productionName ? '-' : ''}` + `${$data.nowChatUserRecordInfo.productionName ? $data.nowChatUserRecordInfo.productionName : ''}`), 1)]),
        _: 1
      }, 8, ["content"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_59, _toDisplayString($data.nowChatUserRecordInfo.mark || ''), 1)]), $data.imgViewerShow ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        onClose: _cache[17] || (_cache[17] = $event => $data.imgViewerShow = false),
        infinite: false,
        "url-list": $data.imgArray,
        "initial-index": $data.imgIndex
      }, null, 8, ["url-list", "initial-index"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_withDirectives(_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", {
        ref: "chat",
        style: {
          "width": "100%",
          "height": "calc(60% - 2rem)",
          "border-top": "1px solid #ccc",
          "padding": "1rem",
          "overflow": "scroll"
        },
        onScroll: _cache[18] || (_cache[18] = (...args) => $options.chatScroll && $options.chatScroll(...args))
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.chatRecordList_new, _chat => {
        return _openBlock(), _createElementBlock("div", {
          style: {
            "width": "100%",
            "flex-wrap": "wrap",
            "margin-bottom": "0.2rem"
          },
          class: _normalizeClass(!_chat.user?.erpPersonalId ? 'flex-start' : 'flex-start')
        }, [_chat.messageType != 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: {
            "width": "100%",
            "color": "#777",
            "font-size": "1rem",
            "margin-top": ".4rem",
            "cursor": "pointer"
          },
          onContextmenu: _withModifiers($event => $options.chatRecall($event, _chat), ["prevent"]),
          class: _normalizeClass(!_chat.user?.erpPersonalId ? 'flex-start' : 'flex-end')
        }, [_createElementVNode("div", {
          style: _normalizeStyle([{
            'background-color': !_chat.user?.erpPersonalId ? '#7FFFD4' : 'pink'
          }, {
            "font-weight": "bold",
            "text-align": "center",
            "padding": ".2rem 0 .2rem .5rem",
            "border-radius": ".4rem 0 0 .4rem"
          }])
        }, _toDisplayString(_chat.user?.name), 5), _createElementVNode("div", {
          style: _normalizeStyle([{
            'background-color': !_chat.user?.erpPersonalId ? '#7FFFD4' : 'pink'
          }, {
            "text-align": "center",
            "padding": ".2rem .5rem .2rem 0",
            "border-radius": "0 .4rem .4rem 0"
          }])
        }, " [" + _toDisplayString(_chat.time) + "]", 5)], 42, _hoisted_64)) : _createCommentVNode("", true), _chat.messageType == 4 ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: {
            "width": "100%",
            "padding": "0 0.2rem"
          },
          class: _normalizeClass(!_chat.user?.erpPersonalId ? 'flex-start' : 'flex-end'),
          onContextmenu: $event => $options.chatClicked(_chat)
        }, [_chat.content.includes('<p>') ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["chat_content", !_chat.user?.erpPersonalId ? 'chat_content_left' : 'chat_content_right']),
          style: {
            "font-size": "1.3rem"
          }
        }, [_createElementVNode("span", {
          innerHTML: _chat.content
        }, null, 8, _hoisted_66)], 2)) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "chat_content",
          innerHTML: _chat.content
        }, null, 8, _hoisted_67)), _chat.user?.erpPersonalId && _chat.showRecall && $data.withdrawShow ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: _normalizeStyle([{
            top: $data.menuTop + 'px',
            left: $data.menuLeft + 'px'
          }, {
            "position": "fixed",
            "background-color": "#D2746A",
            "padding": ".5rem",
            "border-radius": ".4rem",
            "cursor": "pointer",
            "color": "white"
          }])
        }, [_createElementVNode("div", {
          onClick: $event => $options.clickRecall(_chat)
        }, "撤回", 8, _hoisted_68)], 4)) : _createCommentVNode("", true)], 42, _hoisted_65)) : _createCommentVNode("", true), _chat.messageType == 10 ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: {
            "width": "100%",
            "padding": "0 0.2rem"
          },
          class: _normalizeClass(!_chat.user?.erpPersonalId ? 'flex-start' : 'flex-end'),
          onContextmenu: $event => $options.chatClicked(_chat)
        }, [_createVNode(_component_templateTicket, {
          tempTicketData: JSON.parse(_chat.content),
          ref_for: true,
          ref: "ticket",
          isAdmin: true,
          onChange: $options.callBack
        }, null, 8, ["tempTicketData", "onChange"]), _chat.user?.erpPersonalId && _chat.showRecall && $data.withdrawShow ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle([{
            top: $data.menuTop + 'px',
            left: $data.menuLeft + 'px'
          }, {
            "position": "fixed",
            "background-color": "#D2746A",
            "padding": ".5rem",
            "border-radius": ".4rem",
            "cursor": "pointer",
            "color": "white"
          }])
        }, [_createElementVNode("div", {
          onClick: $event => $options.clickRecall(_chat)
        }, "撤回", 8, _hoisted_70)], 4)) : _createCommentVNode("", true)], 42, _hoisted_69)) : _createCommentVNode("", true)], 2);
      }), 256))], 544), _createElementVNode("div", _hoisted_71, [_createVNode(_component_Editor, {
        onKeydown: _cache[19] || (_cache[19] = _withKeys(_withModifiers($event => $options.clickSendContent($event), ["prevent"]), ["enter"])),
        modelValue: $data.sendContent,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.sendContent = $event),
        theme: "chat",
        url: "/api/admin/ChatBase/uploadFile",
        disabled: !$options.canSendMessage,
        onClick: $options.clickUpload
      }, null, 8, ["modelValue", "disabled", "onClick"]), _createElementVNode("div", _hoisted_72, [$setup.isUserApply === 2 || $data.nowChatUserRecordInfo.request_score === 0 ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _cache[21] || (_cache[21] = (...args) => $options.openPoppup && $options.openPoppup(...args)),
        class: "btns"
      }, "申请评价")) : $data.nowChatUserRecordInfo.request_score === 1 ? (_openBlock(), _createElementBlock("button", _hoisted_73, "申请成功")) : $data.nowChatUserRecordInfo.request_score === 3 ? (_openBlock(), _createElementBlock("button", _hoisted_74, "用户已评价")) : _createCommentVNode("", true), $data.nowChatUserRecordInfo.request_score === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_75, "正在申请评价......")) : _createCommentVNode("", true), _createElementVNode("button", {
        onClick: _cache[22] || (_cache[22] = $event => $options.clickShowAI()),
        class: _normalizeClass($data.showAI ? 'btns_green' : 'btns')
      }, "SOP AI", 2), _createElementVNode("button", {
        onClick: _cache[23] || (_cache[23] = $event => $options.clicktempl()),
        class: "btns"
      }, "报损单"), $data.loadingMessage ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 4,
        style: {
          "font-size": "30px",
          "float": "right",
          "left": "50%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon_Loading)]),
        _: 1
      })) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_76, [_createVNode(_component_el_popconfirm, {
        title: $data.nowChatUserRecordInfo && $data.nowChatUserRecordInfo.is_solved ? _ctx._t('unsolvedSure') : _ctx._t('solvedSure'),
        onConfirm: _cache[24] || (_cache[24] = $event => $options.clickSolved($data.nowChatUserRecordInfo))
      }, {
        reference: _withCtx(() => [_createElementVNode("button", {
          class: "btns",
          style: {
            "font-size": ".8rem",
            "background-color": "white"
          },
          disabled: $data.nowChatUserRecordInfo && $data.nowChatUserRecordInfo.is_solved
        }, _toDisplayString($data.nowChatUserRecordInfo && $data.nowChatUserRecordInfo.is_solved ? _ctx._t('unsolved') : _ctx._t('solved')), 9, _hoisted_77)]),
        _: 1
      }, 8, ["title"]), _createElementVNode("button", {
        class: "btns",
        style: {
          "margin-left": "1rem",
          "font-size": ".8rem",
          "background-color": "white"
        },
        onClick: _cache[25] || (_cache[25] = _withModifiers($event => $options.clickSendContent($event), ["stop"])),
        disabled: $data.questionRecordByIdData
      }, _toDisplayString(_ctx._t('send')), 9, _hoisted_78)])]), $data.showAI ? (_openBlock(), _createElementBlock("div", _hoisted_79, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_80, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.AiData, item => {
        return _openBlock(), _createElementBlock("div", _hoisted_81, [_createElementVNode("div", {
          style: {
            "width": "100%",
            "color": "#777",
            "font-size": "1rem"
          },
          class: _normalizeClass(item.role === 'assistant' ? 'flex-start' : 'flex-end')
        }, [_createElementVNode("div", {
          style: _normalizeStyle([{
            'background-color': item.role === 'assistant' ? 'pink' : '#7FFFD4'
          }, {
            "font-weight": "bold",
            "text-align": "center",
            "padding": ".2rem .5rem",
            "border-radius": ".4rem"
          }])
        }, _toDisplayString(item.role === 'assistant' ? 'SOP AI' : 'Me'), 5)], 2), _createElementVNode("div", {
          style: {
            "width": "100%",
            "padding": "0 0.2rem"
          },
          class: _normalizeClass(item.role === 'assistant' ? 'flex-start' : 'flex-end')
        }, [_createElementVNode("div", {
          class: _normalizeClass(item.role === 'assistant' ? 'chat_content_left' : 'chat_content_right'),
          style: {
            "font-size": "1.3rem"
          },
          innerHTML: item.content
        }, null, 10, _hoisted_82)], 2)]);
      }), 256))])), [[_directive_loading, $data._.isEmpty(_ctx.chatReocrd) && ($options.questionRecordSelected.user_unread != 0 || $options.questionRecordSelected.admin_unread != 0)]]), $data.loadingAIChat === true ? (_openBlock(), _createElementBlock("div", _hoisted_83, _hoisted_86)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createElementVNode("button", {
        class: "btns",
        style: {
          "margin-left": "1rem",
          "font-size": ".8rem",
          "background-color": "white"
        },
        onClick: _cache[26] || (_cache[26] = (...args) => $options.clearAIChatHistory && $options.clearAIChatHistory(...args))
      }, "清空聊天记录")]), _withDirectives(_createElementVNode("textarea", {
        class: "textArea",
        onKeydown: _cache[27] || (_cache[27] = _withKeys(_withModifiers($event => $options.clickSendContentBySOPAI(), ["exact"]), ["enter"])),
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.sendAIContent = $event),
        disabled: $options.questionRecordSelected.is_solved || Object.keys($options.questionRecordSelected).length == 0 || _ctx.user.is_readonly,
        name: "",
        id: "",
        cols: "30",
        rows: "10"
      }, null, 40, _hoisted_89), [[_vModelText, $data.sendAIContent]])]), _createElementVNode("div", _hoisted_90, [_createElementVNode("button", {
        class: "btns",
        style: {
          "margin-left": "1rem",
          "font-size": ".8rem",
          "background-color": "white"
        },
        onClick: _cache[29] || (_cache[29] = _withModifiers($event => $options.clickSendContentBySOPAI(), ["stop"])),
        disabled: $options.questionRecordSelected.is_solved || Object.keys($options.questionRecordSelected).length == 0 || _ctx.user.is_readonly
      }, _toDisplayString(_ctx._t('send')), 9, _hoisted_91)])])) : _createCommentVNode("", true)], 512), [[_vShow, $data.isShowTable === false && $data.isTemplShow == false && $data.templateDemoShow == false]]), $data.isShowTable === true && $data.isTemplShow == false && $data.templateDemoShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_92, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        height: "420",
        "highlight-current-row": "",
        "row-key": "key",
        data: $data.customerOrderListData,
        stripe: "",
        "tree-props": {
          children: 'children',
          hasChildren: 'hasChildren'
        },
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "order_create_time",
          label: "订单创建时间",
          width: "120",
          ref: "tempTable"
        }, null, 512), _createVNode(_component_el_table_column, {
          prop: "productions",
          label: "产品",
          width: "200"
        }, {
          default: _withCtx(({
            row,
            column,
            $index
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.productions, item => {
            return _openBlock(), _createElementBlock("p", {
              key: item
            }, _toDisplayString(item), 1);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "orderType",
          label: "订单类型",
          width: "200"
        }, {
          default: _withCtx(({
            row,
            column,
            $index
          }) => [_createElementVNode("p", null, _toDisplayString($options.orderType(row.orderType)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "order_num",
          label: "订单号",
          width: "200"
        }), _createVNode(_component_el_table_column, {
          prop: "estimated_delivery_timestamp",
          label: "用户指定发货日期",
          width: "120"
        }, {
          default: _withCtx(({
            row,
            column,
            $index
          }) => [_createElementVNode("p", null, _toDisplayString(row.estimated_delivery_timestamp ? _ctx.$moment(row.estimated_delivery_timestamp).format("YYYY-MM-DD") : ''), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "apply_waybill_timestamp",
          label: "预计发货日期",
          width: "120"
        }, {
          default: _withCtx(({
            row,
            column,
            $index
          }) => [_createElementVNode("p", null, _toDisplayString(row.apply_waybill_timestamp ? _ctx.$moment(row.apply_waybill_timestamp).format("YYYY-MM-DD") : ''), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "order_status",
          label: "订单状态",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "area",
          label: "下单站点",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "waybill_num",
          label: "运单号",
          width: "200"
        }, {
          default: _withCtx(({
            row,
            column,
            $index
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.waybill_num, item => {
            return _openBlock(), _createElementBlock("p", {
              key: item,
              class: "waybillNum",
              onClick: _withModifiers($event => $options.clickShowTable(item, row), ["stop"])
            }, _toDisplayString(item), 9, _hoisted_93);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "accept_identify_without_batch",
          label: "收件人信息",
          width: "280"
        }, {
          default: _withCtx(({
            row,
            column,
            $index
          }) => [_createElementVNode("p", null, [_hoisted_94, _createTextVNode(_toDisplayString(row.accept_name), 1)]), _createElementVNode("p", null, [_hoisted_95, _createTextVNode(_toDisplayString(row.mobile), 1)]), _createElementVNode("p", null, [_hoisted_96, _createTextVNode(_toDisplayString(row.country), 1)]), _createElementVNode("p", null, [_hoisted_97, _createTextVNode(_toDisplayString(row.Cprovince), 1)]), _createElementVNode("p", null, [_hoisted_98, _createTextVNode(_toDisplayString(row.Ccity), 1)]), _createElementVNode("p", null, [_hoisted_99, _createTextVNode(_toDisplayString(row.county ? row.county : 'None'), 1)]), _createElementVNode("p", null, [_hoisted_100, _createTextVNode(_toDisplayString(row.addr), 1)]), _createElementVNode("p", null, [_hoisted_101, _createTextVNode(_toDisplayString(row.zip), 1)])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "email",
          label: "邮箱",
          width: "220"
        }), _createVNode(_component_el_table_column, {
          prop: "shipping_method",
          label: "运输方式",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "order_amount",
          label: "货物总价值",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "discountAmountArray",
          label: "原价/折扣价(实际价格)/单独折扣率/组合方式",
          width: "300"
        }, {
          default: _withCtx(({
            row,
            column,
            $index
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.discountAmountArray, item => {
            return _openBlock(), _createElementBlock("p", {
              key: item.key
            }, _toDisplayString(item.value), 1);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "140"
        }, {
          default: _withCtx(({
            row,
            column,
            $index
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => $options.clickDownload(row)
          }, {
            default: _withCtx(() => [_hoisted_102]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, $data.orderTableLoading]]), _createVNode(_component_el_dialog, {
        modelValue: $data.dialogTableVisible,
        "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.dialogTableVisible = $event),
        title: '订单号：' + $data.logisticsInformationData.warehouseOrderCode + '|物流信息'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: $data.logisticsInformation
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            property: "utcTime",
            label: "utc时间",
            width: "200"
          }), _createVNode(_component_el_table_column, {
            property: "info",
            label: "信息",
            width: "260"
          }), _createVNode(_component_el_table_column, {
            property: "dateTime",
            label: "北京时间",
            width: "200"
          }), _createVNode(_component_el_table_column, {
            property: "codeInfo",
            label: "状态详情",
            width: "200"
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue", "title"])])) : _createCommentVNode("", true), $data.isTemplShow === true ? (_openBlock(), _createElementBlock("div", _hoisted_103, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        stripe: "",
        height: "440",
        "highlight-current-row": "",
        "row-key": "key",
        data: $data.templRecordList,
        border: "",
        "header-cell-style": {
          'backgroundColor': 'rgb(244,244,244)',
          'textAlign': 'center'
        },
        "cell-style": {
          'height': '50px',
          'backgroundColor': 'white',
          'fontSize': '12px',
          'textAlign': 'center'
        },
        "empty-text": "暂无数据",
        lazy: "",
        load: $options.loadTempTable
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "",
          label: "客诉生成时间",
          width: "120"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString($options.dataTimeFormatter(row.appealTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "purchasingChannelsName",
          label: "产品购买渠道",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "",
          label: "订单编号",
          width: "120"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.orderNum != "null" ? row.orderNum : ""), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "",
          label: "付款时间",
          width: "120"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.paymentTime != "null" ? row.paymentTime : ""), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "deliveryWarehouseName",
          label: "发货仓库",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "merchandiseName",
          label: "商品名称",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "productionName",
          label: "产品名称",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "sopName",
          label: "SOP",
          width: "360"
        }), _createVNode(_component_el_table_column, {
          prop: "tempItemName",
          label: "报损单名称",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "warrantyTypeName",
          label: "质保情况",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "personName",
          label: "发送报损单客服",
          width: "120"
        }), _createVNode(_component_el_table_column, {
          prop: "",
          label: "报损单发送时间",
          width: "120"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString($options.dataTimeFormatter(row.damageReportTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "",
          label: "状态",
          width: "120"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString($options.getTempTextByStatus(row.status)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "120"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            class: "actionButton",
            onClick: $event => $options.viewTemplateRecord(row)
          }, {
            default: _withCtx(() => [_hoisted_104]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style", "load"])), [[_directive_loading, $data.tempTableLoading]]), _createElementVNode("div", _hoisted_105, [_createVNode(_component_el_pagination, {
        "current-page": $data.templcurrentPage,
        "onUpdate:current-page": _cache[31] || (_cache[31] = $event => $data.templcurrentPage = $event),
        "page-size": $data.templpageSize,
        "onUpdate:page-size": _cache[32] || (_cache[32] = $event => $data.templpageSize = $event),
        "page-sizes": [60, 100, 200, 300],
        layout: "total, sizes, prev, pager, next",
        total: $data.templtotal,
        onSizeChange: $options.handleSizeChange,
        onCurrentChange: $options.handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])])])) : _createCommentVNode("", true), $data.templateDemoShow ? (_openBlock(), _createElementBlock("div", _hoisted_106, [_createVNode(_component_templateDemo, {
        templateDemeData: $data.templateDemeData,
        dpt: $data.damageReportContent,
        close: $options.demoClose,
        refresh: $data.refresh,
        "onUpdate:refresh": _cache[33] || (_cache[33] = $event => $data.refresh = $event),
        templatePopFunction: $data.templatePopFunction
      }, null, 8, ["templateDemeData", "dpt", "close", "refresh", "templatePopFunction"])])) : _createCommentVNode("", true)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_107, " 请选择聊天框 "))]), _createVNode(_component_el_drawer, {
        title: "请选择需要分类的目录",
        modelValue: $data.drawer,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.drawer = $event),
        ref: "drawerRef",
        direction: "rtl",
        "before-close": $options.handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_108, [_createVNode(_component_Catalogue, {
          style: {
            "margin-bottom": "30px"
          },
          onGetDirectoryIdInChild: $options.getDirectoryIdInChild
        }, null, 8, ["onGetDirectoryIdInChild"]), _createElementVNode("div", _hoisted_109, [_createVNode(_component_el_button, {
          style: {
            "flex": "1"
          },
          onClick: $options.cancelForm
        }, {
          default: _withCtx(() => [_hoisted_110]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          style: {
            "flex": "1"
          },
          type: "primary",
          onClick: $options.clickSubmit
        }, {
          default: _withCtx(() => [_hoisted_111]),
          _: 1
        }, 8, ["onClick"])])])]),
        _: 1
      }, 8, ["modelValue", "before-close"]), _createVNode(_component_el_drawer, {
        title: "请选择需要分派的客服人员",
        modelValue: $data.drawerAssignment,
        "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.drawerAssignment = $event),
        ref: "drawerAssignmentRef",
        direction: "rtl",
        "before-close": $options.closeAssignment
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_112, [_createVNode(_component_Assignment, {
          onChange: $options.changeCustomerService
        }, null, 8, ["onChange"]), _createElementVNode("div", _hoisted_113, [_createVNode(_component_el_button, {
          style: {
            "flex": "1"
          },
          onClick: $options.cancelAssignment
        }, {
          default: _withCtx(() => [_hoisted_114]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          style: {
            "flex": "1"
          },
          type: "primary",
          onClick: $options.clickSubmitAssignment
        }, {
          default: _withCtx(() => [_hoisted_115]),
          _: 1
        }, 8, ["onClick"])])])]),
        _: 1
      }, 8, ["modelValue", "before-close"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["element-loading-text"])), [[_directive_loading, $data.refresh]])]), $data.popShow_1 ? (_openBlock(), _createBlock(_component_el_dialog, {
    key: 0,
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $data.dialogVisible = $event),
    width: "860px",
    "before-close": $options.diaClose,
    "append-to-body": true,
    "custom-class": "centered-dialog"
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_116, _toDisplayString($data.popInfo), 1)]),
    default: _withCtx(() => [_createVNode(_component_templatePop_1, {
      userAccount: $data.userAccount,
      questionRecordId: $data.nowChatUserRecordInfo.id,
      user: _ctx.user,
      changeTitle: $options.changeTitle,
      nowChatUserRecordInfo: $data.nowChatUserRecordInfo,
      templatePopFunction: $data.templatePopFunction,
      ref: "templatePop"
    }, null, 8, ["userAccount", "questionRecordId", "user", "changeTitle", "nowChatUserRecordInfo", "templatePopFunction"])]),
    _: 1
  }, 8, ["modelValue", "before-close"])) : _createCommentVNode("", true), $data.chShow ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    style: _normalizeStyle([{
      top: $data.chTop + 'px',
      left: $data.chLeft + 'px'
    }, {
      "position": "absolute",
      "background-color": "#D2746A",
      "padding": ".5rem",
      "border-radius": ".4rem",
      "cursor": "pointer",
      "color": "white"
    }]),
    onClick: _cache[37] || (_cache[37] = $event => $options.chTicket($data.chTicketId))
  }, " 撤回 ", 4)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_117, "这是提示信息", 512), [[_vShow, $data.toolTipShow]]), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogLogout,
    "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.dialogLogout = $event),
    width: "30%",
    "show-close": "",
    "before-close": $options.beforeDialogLogout
  }, {
    header: _withCtx(({}) => [_hoisted_118]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_119, [_createElementVNode("div", _hoisted_120, [_createVNode(_component_el_icon, {
      style: {
        "font-size": "50px",
        "color": "rgb(239,161,43)"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon_Warning)]),
      _: 1
    }), _hoisted_121]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_122, [_createVNode(_component_el_button, {
      style: {
        "width": "80px",
        "background-color": "rgba(255, 245,245)",
        "border": "1px solid rgba(210,0,47)",
        "color": "rgba(210,0,47)"
      },
      onClick: _cache[38] || (_cache[38] = $event => $options.clickLogout(0))
    }, {
      default: _withCtx(() => [_hoisted_123]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "width": "80px",
        "margin-left": "30px",
        "background-color": "rgba(210,0,47)",
        "color": "white"
      },
      onClick: _cache[39] || (_cache[39] = $event => $options.clickLogout(1))
    }, {
      default: _withCtx(() => [_hoisted_124]),
      _: 1
    })])])]),
    _: 1
  }, 8, ["modelValue", "before-close"]), _createVNode(_component_el_dialog, {
    modelValue: $data.tipsShow,
    "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => $data.tipsShow = $event),
    width: "30%",
    "show-close": ""
  }, {
    header: _withCtx(({}) => [_hoisted_125]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_126, [_createElementVNode("div", _hoisted_127, [_createVNode(_component_el_icon, {
      style: {
        "font-size": "50px",
        "color": "rgb(239,161,43)"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon_Warning)]),
      _: 1
    }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_128, _toDisplayString($data.tipsTitle), 1), _createElementVNode("div", _hoisted_129, _toDisplayString($data.tipsContent), 1)])]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_130, [_createVNode(_component_el_button, {
      style: {
        "width": "80px",
        "background-color": "rgba(255, 245,245)",
        "border": "1px solid rgba(210,0,47)",
        "color": "rgba(210,0,47)"
      },
      onClick: _cache[41] || (_cache[41] = $event => $options.clickTipsButton(false))
    }, {
      default: _withCtx(() => [_hoisted_131]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "width": "80px",
        "margin-left": "30px",
        "background-color": "rgba(210,0,47)",
        "color": "white"
      },
      onClick: _cache[42] || (_cache[42] = $event => $options.clickTipsButton(true))
    }, {
      default: _withCtx(() => [_hoisted_132]),
      _: 1
    })])])]),
    _: 1
  }, 8, ["modelValue"])]);
}